<div class="dialog">
    <div class="loader screen loading-overlay" *ngIf="loading">
        <img src="assets/svg/preloader.svg" alt="Loading">
    </div>
    <img class="pointer" (click)="close()" src="assets/svg/Multiply.svg" alt="">
    <iframe #iframeRef 
    (load)="onIframeLoad(iframeRef)"
    style="width: 680px;align-self: center;height: 90vh;" 
    [src]="engageUrl" 
    frameborder="0"></iframe>
</div>
<!-- <app-chat-agreement></app-chat-agreement> -->